import { ParticipationRequestStatus } from "../../autogen/bff-api";

// Shared between the buyer's qualification review and the supplier's request list, so a
// relabel/recolor of a verdict can never drift between the two.
// Dynamic keys, listed for langen:
// t('Qualified') t('Not qualified') t('Awaiting review') t('Submitted') t('Draft')
// t('Withdrawn') t('Removed')
export const participationStatusBadge = (
  status: ParticipationRequestStatus,
  // The buyer reads SUBMITTED as work to do; the supplier reads it as a delivery.
  submittedLabelKey: "Awaiting review" | "Submitted" = "Awaiting review",
): { colorScheme: string; labelKey: string } => {
  switch (status) {
    case ParticipationRequestStatus.Qualified:
      return { colorScheme: "green", labelKey: "Qualified" };
    case ParticipationRequestStatus.Rejected:
      return { colorScheme: "red", labelKey: "Not qualified" };
    case ParticipationRequestStatus.Submitted:
      return {
        colorScheme: submittedLabelKey === "Submitted" ? "teal" : "gray",
        labelKey: submittedLabelKey,
      };
    case ParticipationRequestStatus.Withdrawn:
      return { colorScheme: "gray", labelKey: "Withdrawn" };
    case ParticipationRequestStatus.Removed:
      return { colorScheme: "orange", labelKey: "Removed" };
    default:
      return { colorScheme: "gray", labelKey: "Draft" };
  }
};
